export default {
  conversations: state => state.conversations,
}
